"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicPage = exports.getPublicPages = exports.deletePageRelation = exports.postPageRelation = exports.putPageOrganization = exports.putPageAccessibility = exports.deletePagePermission = exports.postPagePermission = exports.putPageAction = exports.delPage = exports.postPage = exports.putPage = exports.getPage = exports.getPages = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var pagesAuthorizedPath = root_1.cmsAuthorized + '/pages/';
var pagesPublicPath = root_1.cmsPublic + '/pages/';

var getPages = function getPages(authentication, queryParameters) {
  return common_1.get(authentication, pagesAuthorizedPath, queryParameters);
};

exports.getPages = getPages;

var getPage = function getPage(authentication, id) {
  return common_1.get(authentication, pagesAuthorizedPath + id);
};

exports.getPage = getPage;

var putPage = function putPage(authentication, page) {
  return common_1.put(authentication, pagesAuthorizedPath + page.id, page);
};

exports.putPage = putPage;

var postPage = function postPage(authentication, page) {
  return common_1.post(authentication, pagesAuthorizedPath, page);
};

exports.postPage = postPage;

var delPage = function delPage(authentication, id) {
  return common_1.del(authentication, pagesAuthorizedPath + id);
};

exports.delPage = delPage;

var putPageAction = function putPageAction(authentication, id, action, data) {
  return common_1.putSub(authentication, pagesAuthorizedPath, id, action, data);
};

exports.putPageAction = putPageAction;

var postPagePermission = function postPagePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, pagesAuthorizedPath, id, permission);
};

exports.postPagePermission = postPagePermission;

var deletePagePermission = function deletePagePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, pagesAuthorizedPath, id, permissionId);
};

exports.deletePagePermission = deletePagePermission;

var putPageAccessibility = function putPageAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, pagesAuthorizedPath, id, accessibility);
};

exports.putPageAccessibility = putPageAccessibility;

var putPageOrganization = function putPageOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, pagesAuthorizedPath, id, organizationId);
};

exports.putPageOrganization = putPageOrganization;

var postPageRelation = function postPageRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, pagesAuthorizedPath, id, relation);
};

exports.postPageRelation = postPageRelation;

var deletePageRelation = function deletePageRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, pagesAuthorizedPath, id, relationId);
};

exports.deletePageRelation = deletePageRelation;

var getPublicPages = function getPublicPages(authentication, queryParameters) {
  return common_1.get(authentication, pagesPublicPath, queryParameters);
};

exports.getPublicPages = getPublicPages;

var getPublicPage = function getPublicPage(authentication, id) {
  return common_1.get(authentication, pagesPublicPath + id);
};

exports.getPublicPage = getPublicPage;